import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@tanstack/react-query';
import { morgansClient } from '../../../lib/connect/clients';
/** Reuse persisted, authorized Tracking Profile explanations. No matching or
 * discovery is run here, and viewing evidence never writes an answer. */ export function QualificationProfileEvidence({ opportunityId }) {
    const result = useQuery({
        queryKey: [
            'qualification',
            'profile-evidence',
            opportunityId
        ],
        queryFn: async ()=>{
            const links = await morgansClient.listCanonicalOpportunityNoticeLinks({
                opportunityId
            });
            const noticeIds = new Set(links.links.map((link)=>link.noticeId));
            if (!noticeIds.size) return [];
            const profiles = await morgansClient.listTrackingProfiles({});
            const evidence = await Promise.all(profiles.profiles.map(async (profile)=>{
                const rows = [];
                for(let offset = 0;; offset += 100){
                    const page = await morgansClient.getMatches({
                        profileId: profile.id,
                        offset,
                        limit: 100
                    });
                    for (const match of page.matches){
                        if (noticeIds.has(match.opportunityNoticeId)) rows.push({
                            id: match.id,
                            profile: profile.name,
                            reasons: match.matchReasons.map((reason)=>`${reason.criterion}: ${reason.value || 'configured criterion'} — ${reason.matched ? 'matched' : 'not matched'}`)
                        });
                    }
                    if (!page.hasMore || !page.matches.length) break;
                }
                return rows;
            }));
            return evidence.flat();
        }
    });
    return /*#__PURE__*/ _jsxs("aside", {
        "aria-label": "Tracking Profile evidence",
        className: "rounded border p-3 space-y-2",
        children: [
            /*#__PURE__*/ _jsx("h4", {
                children: "Tracking Profile evidence"
            }),
            /*#__PURE__*/ _jsx("p", {
                children: "Existing explanations support your strategic judgment. A match or AI summary never sets disposition."
            }),
            result.isLoading && /*#__PURE__*/ _jsx("p", {
                children: "Loading profile explanations…"
            }),
            result.isError && /*#__PURE__*/ _jsx("p", {
                children: "Profile evidence unavailable. Continue with a manual judgment and remaining uncertainty."
            }),
            result.data?.length === 0 && /*#__PURE__*/ _jsx("p", {
                children: "No permitted Profile explanation for the linked Notices."
            }),
            result.data?.map((match)=>/*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("strong", {
                            children: match.profile
                        }),
                        " · ",
                        match.id,
                        /*#__PURE__*/ _jsx("ul", {
                            children: match.reasons.map((reason)=>/*#__PURE__*/ _jsx("li", {
                                    children: reason
                                }, reason))
                        })
                    ]
                }, match.id))
        ]
    });
}
